import { put, call, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';


function* breachAdd(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function(payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('comment', payload.comment);
    return axios.post(config.apiUri + "member/breachAddApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.bool) {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: res.data.comment} });
      action.callback();
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }

  yield put(loadingSet(false));
}

const saga = [
  takeLatest('BREACH_ADD', breachAdd),
];

export default saga;
